import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Policies.css';

function DistanceSalesAgreement() {
  return (
    <Container className="policy-page py-5">
      <h1 className="text-center mb-5">Mesafeli Satış Sözleşmesi</h1>
      
      <Row className="g-4">
        <Col lg={8} className="mx-auto">
          <Card className="policy-card">
            <Card.Body>
              <section className="mb-5">
                <h4>1. Taraflar</h4>
                <p>
                  SATICI: Mr. Brown<br />
                  Adres: Ahatlı Mahalle, 3151 sokak, Kepez, Antalya<br />
                  Telefon: +90 535 873 46 92<br />
                  E-posta: mr.browncases@gmail.com
                </p>
                <p>
                  ALICI: Web sitesi üzerinden alışveriş yapan müşteri
                </p>
              </section>

              <section className="mb-5">
                <h4>2. Sözleşmenin Konusu</h4>
                <p>
                  İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait internet sitesinden elektronik ortamda siparişini verdiği aşağıda nitelikleri ve satış fiyatı belirtilen ürünün satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.
                </p>
              </section>

              <section className="mb-5">
                <h4>3. Ürün Bilgileri</h4>
                <p>
                  Ürünlere ait temel özellikler, satış fiyatı ve ödeme bilgileri internet sitesinde yer almaktadır. 
                  Satış fiyatına tüm vergiler dahildir.
                </p>
              </section>

              <section className="mb-5">
                <h4>4. Teslimat Koşulları</h4>
                <ul className="policy-list">
                  <li>Teslimat, anlaşmalı kargo şirketleri aracılığıyla yapılacaktır.</li>
                  <li>Teslimat süresi, ürünün türüne göre 2-7 iş günü arasında değişmektedir.</li>
                  <li>Özel tasarım ürünlerde üretim süresi eklenecektir.</li>
                  <li>Teslimat, ALICI'nın sipariş formunda belirttiği adrese yapılacaktır.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>5. Cayma Hakkı</h4>
                <ul className="policy-list">
                  <li>ALICI, hiçbir hukuki ve cezai sorumluluk üstlenmeksizin ve hiçbir gerekçe göstermeksizin, malı teslim aldığı tarihten itibaren 14 (on dört) gün içerisinde malı iade etme hakkına sahiptir.</li>
                  <li>Cayma hakkı süresi, malın teslim tarihinden itibaren başlar.</li>
                  <li>Özel üretim (kişiselleştirilmiş) ürünlerde cayma hakkı kullanılamaz.</li>
                  <li>İade edilen ürün, orijinal ambalajında ve kullanılmamış olmalıdır.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>6. Ödeme ve Teslimat</h4>
                <ul className="policy-list">
                  <li>Ödeme, internet sitesinde belirtilen ödeme yöntemleri ile yapılabilir.</li>
                  <li>Kredi kartı ile yapılan ödemelerde, kart bilgileri satıcı tarafından görüntülenemez.</li>
                  <li>Ürün bedeli, teslimat ücretini kapsamaz (300 TL üzeri alışverişlerde kargo ücretsizdir).</li>
                </ul>
              </section>

              <section>
                <h4>7. Genel Hükümler</h4>
                <ul className="policy-list">
                  <li>Bu sözleşme, taraflar arasında elektronik ortamda kabul edilmekle yürürlüğe girer.</li>
                  <li>ALICI, sözleşmedeki bilgilerin doğruluğunu kabul ve beyan eder.</li>
                  <li>Sözleşmeden doğan uyuşmazlıklarda Türk Hukuku uygulanır.</li>
                  <li>Uyuşmazlık durumunda Antalya Mahkemeleri ve İcra Daireleri yetkilidir.</li>
                </ul>
                <p className="mt-4">
                  Bu mesafeli satış sözleşmesi, ALICI tarafından elektronik ortamda okunup kabul edildikten sonra 
                  sipariş tamamlanabilir. ALICI, bu sözleşmeyi kabul ederek, sözleşme konusu siparişi onayladığını 
                  kabul eder.
                </p>
              </section>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default DistanceSalesAgreement; 